var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "modifyForm",
          attrs: { model: _vm.modifyForm, "label-width": "100px" },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "不合格原因",
                        prop: "causeOfNonconformity",
                      },
                    },
                    [
                      _c("ic-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          table: "TT_QSPI_QIP",
                          field: "CAUSE_OF_NONCONFORMITY",
                          clearable: "",
                          placeholder: "请选择",
                        },
                        model: {
                          value: _vm.modifyForm.causeOfNonconformity,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "causeOfNonconformity",
                              $$v
                            )
                          },
                          expression: "modifyForm.causeOfNonconformity",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "风险等级", prop: "riskGrade" } },
                    [
                      _c("ic-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: "",
                          table: "TT_QSPI_QIP",
                          field: "RISK_GRADE",
                          placeholder: "请选择",
                        },
                        model: {
                          value: _vm.modifyForm.riskGrade,
                          callback: function ($$v) {
                            _vm.$set(_vm.modifyForm, "riskGrade", $$v)
                          },
                          expression: "modifyForm.riskGrade",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "处理方式", prop: "processingMode" } },
                    [
                      _c("ic-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: "",
                          table: "TT_QSPI_QIP",
                          field: "PROCESSING_MODE",
                          placeholder: "请选择",
                        },
                        model: {
                          value: _vm.modifyForm.processingMode,
                          callback: function ($$v) {
                            _vm.$set(_vm.modifyForm, "processingMode", $$v)
                          },
                          expression: "modifyForm.processingMode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "责任方", prop: "responsibleParty" } },
                    [
                      _c("ic-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: "",
                          table: "TT_QSPI_QIP",
                          field: "RESPONSIBLE_PARTY",
                          placeholder: "请选择",
                        },
                        model: {
                          value: _vm.modifyForm.responsibleParty,
                          callback: function ($$v) {
                            _vm.$set(_vm.modifyForm, "responsibleParty", $$v)
                          },
                          expression: "modifyForm.responsibleParty",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "责任方是否已确认",
                        prop: "responsibleConfirm",
                      },
                    },
                    [
                      _c("ic-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: "",
                          table: "TT_QSPI_QIP",
                          field: "RESPONSIBLE_CONFIRM",
                          placeholder: "请选择",
                        },
                        model: {
                          value: _vm.modifyForm.responsibleConfirm,
                          callback: function ($$v) {
                            _vm.$set(_vm.modifyForm, "responsibleConfirm", $$v)
                          },
                          expression: "modifyForm.responsibleConfirm",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "QIP_Owner备注", prop: "ownerRemarks" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          maxlength: "1000",
                          "show-word-limit": "",
                          autosize: { minRows: 4, maxRows: 6 },
                          placeholder: "请输入内容",
                        },
                        model: {
                          value: _vm.modifyForm.ownerRemarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.modifyForm, "ownerRemarks", $$v)
                          },
                          expression: "modifyForm.ownerRemarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          staticStyle: { "margin-top": "10px" },
          attrs: { type: "flex", justify: "center" },
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.onSave },
            },
            [_vm._v("保存")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.onCancel },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }